/**
 * PRX-83: which top-bar quick actions render. Operations dashboard, All orders
 * and Task queue are already in the left sidebar; the "Search Rx, patient or
 * order" action (PRX-15) duplicates the top-bar search box. New order stays —
 * it is the one action with no other home. PRX-54 (R5) replaced the hidden
 * set below with the per-pharmacy visibility resolver — see the
 * `topbar.action.*` defaults in `visibility/visibilityCatalogue.ts`, which
 * reproduce this exact set (four hidden, New order shown) through
 * `resolveBlockHidden()`/`useBlocksHidden()`.
 */
export const TOPBAR_QUICK_ACTION_KEYS = [
  'operations_dashboard',
  'search',
  'new_order',
  'all_orders',
  'task_queue',
] as const;

export type TopbarQuickActionKey = (typeof TOPBAR_QUICK_ACTION_KEYS)[number];

export function visibleTopbarQuickActions<T extends { key: TopbarQuickActionKey }>(
  actions: readonly T[],
  isHidden: (blockKey: string) => boolean,
): T[] {
  return actions.filter((action) => !isHidden(`topbar.action.${action.key}`));
}
